// Component imports
import { useAnalytics } from '@praxis/analytics/client'
import { lazy, Suspense, useEffect } from 'react'
import { PAGELOAD_HOME } from '../../analytics/events'
import BrandCarousel from '../../components/BrandsSection/brandCarousel'
import Footer from '../../components/Footer/footer'
import HeroBanner from '../../components/HeroBanner/heroBanner'
import styles from './home.module.scss'
import { flag } from '../../flag/index'

const SECTIONS_CONFIG = [
  {
    id: 'metrics',
    component: lazy(
      () => import('../../components/MetricsSection/metricsSection'),
    ),
    hasScrollMargin: false,
  },
  {
    id: 'why-target-plus',
    component: lazy(
      () => import('../../components/WhyTargetPlus/whyTargetPlus'),
    ),
    hasScrollMargin: true,
    bgColor: 'bgLightBeige',
  },
  {
    id: 'partnership',
    component: lazy(() => import('../../components/Partnership/partnership')),
    hasScrollMargin: false,
  },
  {
    id: 'how-it-works',
    component: lazy(() => import('../../components/HowItWorks/howItWorks')),
    hasScrollMargin: true,
    bgColor: 'bgLightBeige',
  },
  {
    id: 'channel-partners',
    component: lazy(
      () => import('../../components/ChannelPartners/channelPartners'),
    ),
    hasScrollMargin: false,
  },
  {
    id: 'resources',
    component: lazy(
      () => import('../../components/FaqsAndResources/faqsAndResources'),
    ),
    hasScrollMargin: true,
    bgColor: 'bgDarkGray',
  },
  {
    id: 'apply',
    component: lazy(() => import('../../components/ApplyNow/applyNow')),
    hasScrollMargin: false,
    bgColor: 'bgRed',
  },
]

const Section = ({ id, children, hasScrollMargin }) => (
  <section
    id={id}
    style={hasScrollMargin ? { scrollMarginTop: '80px' } : undefined}
  >
    {children}
  </section>
)

const Home = () => {
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    // Track page load
    sendEvent({
      event: {
        type: 'PAGE_VIEW',
        value: PAGELOAD_HOME,
      },
    })
  }, [sendEvent])

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '')
      const element = document.getElementById(id)

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [])

  return (
    <>
      <Section hasScrollMargin={true} id="home" key="home">
        <HeroBanner />
      </Section>
      <Section hasScrollMargin={false} key="brand-carousel">
        <BrandCarousel />
      </Section>
      {SECTIONS_CONFIG.map(
        ({
          id,
          component: Component,
          hasScrollMargin,
          bgColor,
          isBlurEffect,
        }) => {
          const resolvedBgColor =
            id === 'channel-partners'
              ? flag('TPLUS_REVAMP')
                ? ''
                : 'bgLightGray'
              : bgColor

          return (
            <div className={styles[resolvedBgColor]} key={id}>
              <div
                className={`${styles.homeSectionContainer} ${
                  isBlurEffect ? styles.addBlurEffect : ''
                }`}
              >
                <Section id={id} hasScrollMargin={hasScrollMargin}>
                  <Suspense fallback={<div className="suspenseFallback" />}>
                    <Component />
                  </Suspense>
                </Section>
              </div>
            </div>
          )
        },
      )}
      <Section hasScrollMargin={false} key="footer">
        <Footer />
      </Section>
    </>
  )
}

export default Home
